export const EDIT_SUCCESS = 'Настройки обновлены';
export const EDIT_ERROR = 'Не удалось обновить настройки';
